const ACCESS_TOKEN_KEY = 'sanjeevani_access_token'
const REFRESH_TOKEN_KEY = 'sanjeevani_refresh_token'
const EXPIRES_AT_KEY = 'sanjeevani_token_expires_at'

export const tokenStorage = {
  save(accessToken: string, refreshToken?: string, expiresInSeconds = 3600) {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
    if (refreshToken) {
      localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
    }

    localStorage.setItem(EXPIRES_AT_KEY, String(Date.now() + expiresInSeconds * 1000))
  },

  getAccessToken(): string | null {
    return localStorage.getItem(ACCESS_TOKEN_KEY)
  },

  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY)
  },

  hasRefreshToken(): boolean {
    return !!localStorage.getItem(REFRESH_TOKEN_KEY)
  },

  isExpired(): boolean {
    const expiresAt = localStorage.getItem(EXPIRES_AT_KEY)
    return !expiresAt || Date.now() >= Number(expiresAt)
  },

  clear() {
    localStorage.removeItem(ACCESS_TOKEN_KEY)
    localStorage.removeItem(REFRESH_TOKEN_KEY)
    localStorage.removeItem(EXPIRES_AT_KEY)
  },
}
